import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";

const useOverlayStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: "0px",
    left: "0px",
    zIndex: 5,
    backgroundColor: "transparent",
    display: "flex",
    flexDirection: "columns",
    alignItems: "start",
    justifyContent: "start",
    pointerEvents: "none"
  }
}));

export default function GeneralOverlay(props) {
  const classes = useOverlayStyles();
  return (
    <Typography>
      <Box
        fontWeight="fontWeightBold"
        color="primary.contrastText"
        fontSize={10}
        className={classes.root}
      >
        {...props.children}
      </Box>
    </Typography>
  );
}
